
import { Options, Vue } from "vue-class-component";
import Toaster from "../helpers/Toaster";
import { reactive } from "vue";
import ProfilerService from "../service/ProfilerService.js";
import useVuelidate, { Validation } from "@vuelidate/core";
import {
    helpers,
    required,
    email,
    minLength,
    maxLength,
    minValue,
    maxValue,
    numeric,
} from "@vuelidate/validators";
import { ref } from "vue";
import { mixins } from "vue-class-component";
import UtilityOptions from "../mixins/UtilityOptions";

@Options({
    props: {
        profilerDetail: Object,
    },
    watch: {
        profilerDetail(obj) {
            this.item.accountType = { key: obj.accountType ? obj.accountType : null };
            if (obj.statusType == "New") {
                this.previewOnly = false;
                this.updateUnavailable = false;
                this.openDialog();
            } else if (obj.statusType == "Update") {
                this.previewOnly = false;
                this.updateUnavailable = true;
                this.item.id = obj.profilerID;
                this.editIem();
            } else if (obj.statusType == "Preview") {
                this.previewOnly = true;
                this.updateUnavailable = false;
                this.item.id = obj.profilerID;
                this.editIem();
            } else {
                this.dialogTitle = "";
            }

            this.dialogTitle = obj.dialogTitle;
            this.productDialog = obj.status;
            this.currentUserID = obj.currentUserID;
            this.profileTypes = obj.profileTypes;
        },
        'state.accountType'(newVal) {
            this.item.accountType = newVal;
        },
    },
    emits: ["updateProfilerStatus"],
})
export default class ProfilerDialog extends mixins(UtilityOptions) {
    private toast;
    private submitted = false;
    private productDialog = false;
    private previewOnly = false;
    private updateUnavailable = false;
    private dialogTitle = "";
    private profilerService;
    private currentUserID = 0;
    private profileTypes: { key: string }[] | null = null;
    private beErrors = [];

    private item: {
        id: number;
        accountType: { key: string } | null;
        status: string;
    } = {
        id: 0,
        accountType: null,
        status: "Active",
    };

    private state = reactive({
        accountTitle: "",
        contactNo: "",
        emailAddress: "",
        nationalId: "",
        address: "",
        accountType: null as { key: string } | null, 
        description: "",
        company: "",
        defaultExpiryAlertDuration: 90,
    });

    clearErrors(key_param) {
        this.beErrors = [];
    }

    nationalIdValidation(value) {
        if (value == "") {
            return true;
        }
        if (!this.validateNic(value)) {
            return false;
        }
        return true;
    }

    decimalValidator(value) {
        const decimalPattern = /^\d+$/; // Restrict to max 2 decimal places
        return decimalPattern.test(value);
    }

    validateMobileNo(value) {
        if (!this.validateMobileNumber(value)) {
            return false;
        }
        return true;
    }

    get validationRules() {
        return reactive({
            accountTitle: {
                required: helpers.withMessage("Name is Required", required),
                minLength: helpers.withMessage(
                    "Name should be at least 3 characters long",
                    minLength(3)
                ),
                maxLength: maxLength(50),
            },
            contactNo: {
                required: helpers.withMessage(
                    "Contact Number is Required",
                    required
                ),
                numeric: helpers.withMessage(
                    "Contact Number should be numeric",
                    numeric
                ),
                validateMobileNo: helpers.withMessage(
                    "Invalid Contact Number",
                    this.validateMobileNo
                ),
                decimalValidator: helpers.withMessage(
                    "Invalid Contact Number",
                    this.decimalValidator
                ),
            },
            emailAddress: {
                email: helpers.withMessage("Invalid Email Address", email),
            },
            nationalId: {
                nationalIdValidation: helpers.withMessage(
                    "Invalid National ID",
                    this.nationalIdValidation
                ),
            },
            address: {
                maxLength: maxLength(200),
            },
            accountType: {
                required: helpers.withMessage("Account Type is required", required),
            },
            description: {
                maxLength: maxLength(100),
            },
            company: {
                maxLength: maxLength(100),
            },
            defaultExpiryAlertDuration: {
                required: helpers.withMessage(
                    "Expiry Notice Period is Required",
                    required
                ),
                decimalValidator: helpers.withMessage(
                    "Invalid Expiry Notice Period",
                    this.decimalValidator
                ),
                numeric: helpers.withMessage(
                    "Enter valid number of days",
                    numeric
                ),
                minValue: minValue(0),
                maxValue: helpers.withMessage(
                    "The maximum day count should be less than 365",
                    maxValue(365)
                ),
            },
        });
    }
    private v$ = useVuelidate(this.validationRules, this.state);

    private profilerTypes: { key: string }[] = [
        { key: "Customer" },
        { key: "Supplier" },
        // { key: "Salesman" },
        // { key: "Default Customer" },
    ];

    //DEFAULT METHOD OF TYPE SCRIPT
    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.profilerService = new ProfilerService();
        this.toast = new Toaster();
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        if (this.profileTypes) {
            this.profilerTypes = this.profileTypes;
            // this.item.accountType = this.profileTypes[0];
            if (this.profileTypes.length === 1) {
                this.state.accountType = this.profileTypes[0];
                this.item.accountType = this.profileTypes[0];
            }
        }
        this.submitted = false;
        this.productDialog = true;
    }

    clearItems() {
        this.item = {
            id: 0,
            accountType: { key: "Customer" },
            status: "Active",
        };

        this.state.accountTitle = "";
        this.state.contactNo = "";
    }

    closeDialog() {
        this.$emit("updateProfilerStatus", ["", {}]);
        this.productDialog = false;
        this.clearItems();
        this.clearProfile();
    }

    //ADD OR UPDATE THE ITEM VIA HTTP
    saveItem(isFormValid) {
        this.submitted = true;
        this.item.accountType = this.state.accountType;
        if (isFormValid) {
            if (this.item.id != 0) {
                this.profilerService
                    .updateItem(this.item, this.state)
                    .then((res) => {
                        this.$emit("updateProfilerStatus", ["load", {}]);
                        //SHOW NOTIFICATION
                        this.toast.handleResponse(res);

                        this.productDialog = false;
                        // this.clearItems();
                        this.clearProfile();
                    });
            } else {
                this.profilerService
                    .saveItem(this.item, this.state, this.currentUserID)
                    .then((res) => {
                        if (res.errors == undefined && res.alert != "danger") {
                            this.$emit("updateProfilerStatus", [
                                "load",
                                res.profileDetail,
                            ]);
                            //SHOW NOTIFICATION
                            this.toast.handleResponse(res);
                            this.clearProfile();
                        } else {
                            this.beErrors = res.errors;
                            if (res.alert == "danger") {
                                this.toast.handleResponse(res);
                            }
                        }
                    });
            }
        }
    }

    clearProfile() {
        this.state.accountTitle = "";
        this.state.contactNo = "";
        this.state.emailAddress = "";
        this.state.nationalId = "";
        this.state.address = "";
        this.state.company = "";
        this.state.description = "";
        if (!this.profilerTypes || this.profilerTypes.length > 1) {
            this.state.accountType = null;
        }
    }

    //OPEN DIALOG BOX TO EDIT
    editIem() {
        this.submitted = false;
        this.dialogTitle = "Update Profile";
        this.productDialog = true;
        this.profilerService.getItem(this.item).then((res) => {
            if (res.length > 0) {
                this.state.accountTitle = res[0].account_title;
                this.state.emailAddress =
                    res[0].email_address == null ? "" : res[0].email_address;
                this.state.contactNo =
                    res[0].contact_no == null ? "" : res[0].contact_no;
                this.state.nationalId =
                    res[0].national_id == null ? "" : res[0].national_id;
                this.state.address =
                    res[0].address == null ? "" : res[0].address;
                this.state.description =
                    res[0].description == null ? "" : res[0].description;
                const accountType = res[0].account_type
                ? {key: res[0].account_type}
                : null;
                this.item.accountType = accountType;
                this.state.accountType = accountType;
                this.item.status = res[0].status;
            }
        });
    }

    focusNext(refName, event, special) {
        var tempElement = document.getElementById(refName);
        if (special) {
        }

        if (tempElement) {
            tempElement.focus();
        }
    }
}
